import React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import QuoteForm from './Components/QuoteForm';
import ReviewForm from './Components/ReviewForm';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>
  },
  {
    path: "/getquote",
    element: <QuoteForm/>
  },
  {
    path: "/writereview",
    element: <ReviewForm />
  }

])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router}/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
